module.exports = __webpack_public_path__ + "img/header-diamondJewelryBudgetHigh.572104e.webp";